import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, PopoverController, NavParams, ModalController, ToastController, AlertController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { VehicleService } from '../../vehicles';
import { FueldropdetailsPage } from '../fueldropdetails/fueldropdetails';
import { ConfirmreqPage } from '../confirmreq/confirmreq';
import { PopupPage } from '../popup/popup';

/**
 * Generated class for the NotificationmodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;
declare var RichMarker;
declare var RichMarkerPosition;
@Component({
  selector: 'page-notificationmodal',
  templateUrl: 'notificationmodal.html',
})
export class NotificationmodalPage {
  MapNotif: any;
  @ViewChild('mapNotif') mapElement: ElementRef;
  alert: any;
  historyObj: any;

  zonename = '';
  zoneid = '';
  zonecolor = '';
  fuelparams = [];
  dataLoaded = false;

  kraenDatumFuel: any;
  pochetenDatumFuel: any;
  dtfueldown: any;
  pochFuel: any;
  kraenFuel: any;
  totalFuelDown: number;

  zabeleshka: any = ''
  mustnote = false;
  deblockBtn = false;
  myInterval: any
  sectodeblock: number = -1

  bletemp = ''
  blehumidity = ''
  servComp = ''
  routeId = ''
  multirfidOldVeh = ''
  multirfidDriver = ''
  alerttypenlb = ''
  alerttypenlbtxt = ''
  ekipa = ''
  whours = ''
  livespeedwarning = false

  constructor(public popoverCtrl: PopoverController, public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public vs: VehicleService, public modalCtrl: ModalController, public toastCtrl: ToastController, public alertCtrl: AlertController) {

    this.alert = this.navParams.get('alert');
    this.alert.datumformated = moment(this.alert.datetime).format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat)

    if (this.alert.name == 'draeger') {
      this.alert.datumformated1 = moment(this.alert.info.split('^^^')[0]).format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat)

      this.alert.avalue = this.alert.info.split('^^^')[1]
      this.alert.avalueDraegerDriver = this.alert.info.split('^^^')[2]

    }

    this.alerttypenlb = this.alert.notetype
    this.alerttypenlbtxt = this.dic.l[this.alert.notetype]

    this.zabeleshka = this.alert.note;
    this.mustnote = this.navParams.get('mustnote');
    this.livespeedwarning = this.navParams.get('livespeedwarning');

    // console.log(this.alert)

    if (this.alert.name == "enterZone") {
      this.getZoneDetails(1)
    }
    if (this.alert.name == "leaveZone") {
      this.getZoneDetails(0)
    }
    if (this.alert.name == "fueldown") {
      this.getFuelDownDetails()
    }

    if (this.alert.name == "bluetoothtemphigh" || this.alert.name == "bluetoothtemplow") {
      this.bluetoothtemp()
    }
    if (this.alert.name == 'serviceCompExpire') {
      this.servComp = this.alert.info
    }
    if (this.alert.name == 'generatorService') {
      if (parseInt(this.alert.info) < 0) {
        this.whours = this.dic.l["exceeded"] + ' ' + Math.abs(this.alert.info) + ' h'
      } else {
        this.whours = this.alert.info + ' h ' + this.dic.l["untilNextService"]
      }
    }
    if (this.alert.name == 'ignOffInRoute' || this.alert.name == 'openDoorsOutPoiInRoute' || this.alert.name == 'openSafeDoor' || this.alert.name == 'openDriversDoorInRoute' || this.alert.name == 'openCoDriversSideDoorInRoute') {
      this.routeId = this.alert.info.split('%%%')[0]
      this.ekipa = this.alert.info.split('%%%')[1]
    }

    if (this.alert.name == 'openDoorsOutPoiInRoute' || this.alert.name == 'openSafeDoor' || this.alert.name == 'openCoDriversSideDoorInRoute') {
      var doorsarr = this.alert.info.split('%%%')[2].split(',')
      var doors = []
      for (var i = 0; i < doorsarr.length - 1; i++) {
        doors.push(this.dic.l[doorsarr[i]])
      }
      this.alert.adoors = doors.join(', ');
    }
    if (this.alert.name == 'rfidmultiveh') {
      this.multirfidOldVeh = this.alert.info.split('~')[0]
      this.multirfidDriver = this.alert.info.split('~')[1]
    }

    if (this.alert.name == 'bluehumiditylow' || this.alert.name == 'bluehumidityhigh') {
      this.gethumidity()
    }

    if (this.alert.name == "leaveRoute") {
      if (parseFloat(this.alert.info.split('|')[1]) > 1000)
        this.alert.leaveRouteDesc = this.RoundFloat(parseFloat(this.alert.info.split('|')[1]) / 1000) + ' Km';
      else
        this.alert.leaveRouteDesc = this.RoundFloatCeil(parseFloat(this.alert.info.split('|')[1])) + ' m';
      this.alert.leaveRouteDesc += ' (дозволено: ' + this.RoundFloat(parseFloat(this.alert.info.split('|')[0])) + ' m)'
    }

    if (this.alert.name == "openedDoorOutZone") {
      var doorsarr = this.alert.info.split('|')[1].split(',')
      this.alert.azones = this.alert.info.split('|')[0]
      var doors = []
      for (var i = 0; i < doorsarr.length - 1; i++) {
        doors.push(this.dic.l[doorsarr[i]])
      }
      this.alert.doors = doors.join(', ');
    }

    if (this.alert.name == "beaconrecognize") {
      this.alert.beacon = this.alert.info.split('|')[0]
      this.alert.beaconvehicle = this.alert.info.split('|')[1]
    }
    if (this.alert.name == "techMalfunction") {
      var oilCoolantAirbag = this.alert.info.split('|')[0]
      var warningsFailures = this.alert.info.split('|')[1]
      this.alert.techmaldesc = []
      this.alert.techmalimg = []

      var oilPressure = parseInt(oilCoolantAirbag.substring(6, 7)); //nisko nivo na maslo
      if (oilPressure == 1) {
        this.alert.techmaldesc.push(this.dic.l['oilpressure'])
        this.alert.techmalimg.push('oilpressure2.png')
      }
      var coolantLiquid = parseInt(oilCoolantAirbag.substring(5, 6)); //nisko nivo na antifriz
      if (coolantLiquid == 1) {
        this.alert.techmaldesc.push(this.dic.l['coolantliquid'])
        this.alert.techmalimg.push('coolantliquid.png')
      }
      var handBrakeSystem = parseInt(oilCoolantAirbag.substring(4, 5)); //slika izvicnik so racna, opis: problem so racna kocnica
      if (handBrakeSystem == 1) {
        this.alert.techmaldesc.push(this.dic.l['handbrakesystem'])
        this.alert.techmalimg.push('handbrake1.png')
      }
      var batteryCharging = parseInt(oilCoolantAirbag.substring(3, 4)); //problem so napojuvanje
      if (batteryCharging == 1) {
        this.alert.techmaldesc.push(this.dic.l['batterycharging'])
        this.alert.techmalimg.push('batterycharging.png')
      }
      var airBag = parseInt(oilCoolantAirbag.substring(2, 3)); //
      if (airBag == 1) {
        this.alert.techmaldesc.push(this.dic.l['airbag'])
        this.alert.techmalimg.push('airbag.png')
      }

      var checkEngine = parseInt(warningsFailures.substring(7, 8));  //check engine
      if (checkEngine == 1) {
        this.alert.techmaldesc.push(this.dic.l['checkengine'])
        this.alert.techmalimg.push('checkengine.png')
      }
      var lightsFailure = parseInt(warningsFailures.substring(6, 7)); //neispravna sijalica
      if (lightsFailure == 1) {
        this.alert.techmaldesc.push(this.dic.l['lightsfailure'])
        this.alert.techmalimg.push('lightsfailure.png')
      }
      var lowTirePressure = parseInt(warningsFailures.substring(5, 6)); //slabi gumi
      if (lowTirePressure == 1) {
        this.alert.techmaldesc.push(this.dic.l['lowtirepressure'])
        this.alert.techmalimg.push('lowtirepressure.png')
      }
      var wearOfBreakPads = parseInt(warningsFailures.substring(4, 5)); //istroseni plocki za kocnica
      if (wearOfBreakPads == 1) {
        this.alert.techmaldesc.push(this.dic.l['wearofbreakpads'])
        this.alert.techmalimg.push('wearofbreakpads.png')
      }
      var warning = parseInt(warningsFailures.substring(3, 4)); //predupreduvanje
      if (warning == 1) {
        this.alert.techmaldesc.push(this.dic.l['warning'])
        this.alert.techmalimg.push('warning.png')
      }
      var ABS = parseInt(warningsFailures.substring(2, 3)); //problem so abs
      if (ABS == 1) {
        this.alert.techmaldesc.push(this.dic.l['abs'])
        this.alert.techmalimg.push('abs.png')
      }
      var lowFuel = parseInt(warningsFailures.substring(1, 2)); //gorivo rezerva
      if (lowFuel == 1) {
        this.alert.techmaldesc.push(this.dic.l['lowfuel'])
        this.alert.techmalimg.push('lowfuel.png')
      }
    }
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  getZoneDetails(inout: any) {
    var _that = this;
    this.gn._Post('/api/gn/gethistoryalarmzone', { vid: this.gn.crypt(this.alert.vehicleid), dt: this.gn.crypt(this.alert.datatext), inout: this.gn.crypt(inout) }, function (_data) {
      if (_data.length > 0) {
        _that.zoneid = _data[0].id
        _that.zonename = _data[0].name
        _that.zonecolor = _data[0].fillcolor
        _that.historyObj.zonenames = _that.zonename
      }
    })
  }

  getFuelDownDetails() {
    var _that = this;
    this.gn._Post('/api/gn/gethistoryalarmfueldown', { vid: this.gn.crypt(this.alert.vehicleid), dt: this.gn.crypt(this.alert.datatext) }, function (_data) {
      _that.fuelparams = _data[0].fueldown.split('|')
      // _that.kraenDatumFuel = _data[0].datatext;
      _that.pochetenDatumFuel = moment(_that.fuelparams[1]).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat);
      _that.dtfueldown = _that.fuelparams[1]
      _that.pochFuel = _that.fuelparams[0];
      _that.kraenFuel = _that.fuelparams[2];
      _that.totalFuelDown = Math.abs(parseInt(_that.kraenFuel) - parseInt(_that.pochFuel))
      // console.log('GORAN',_data)
      // console.log(_that.fuelparams)
    })
  }

  bluetoothtemp() {
    var _that = this;
    this.gn._Post('/api/gn/getbluetoothtemp', { vid: this.gn.crypt(this.alert.vehicleid), dt: this.gn.crypt(this.alert.datatext) }, function (_data) {
      var bletempArr = []
      if (_data[0].bletemp1 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot1')) {
        bletempArr.push(_data[0].slot1name + ': ' + _data[0].bletemp1 + ' °' + _that.gn.user.tempunit)
      }
      if (_data[0].bletemp2 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot2')) {
        bletempArr.push(_data[0].slot2name + ': ' + _data[0].bletemp2 + ' °' + _that.gn.user.tempunit)
      }
      if (_data[0].bletemp3 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot3')) {
        bletempArr.push(_data[0].slot3name + ': ' + _data[0].bletemp3 + ' °' + _that.gn.user.tempunit)
      }
      if (_data[0].bletemp4 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot4')) {
        bletempArr.push(_data[0].slot4name + ': ' + _data[0].bletemp4 + ' °' + _that.gn.user.tempunit)
      }
      _that.bletemp = bletempArr.join(', ');
    })
  }

  gethumidity() {
    var _that = this
    this.gn._Post('/api/gn/getbluetoothhumidity', { vid: this.gn.crypt(this.alert.vehicleid), dt: this.gn.crypt(this.alert.datatext) }, function (_data) {
      var blehumidityArr = []
      if (_data[0].blehumidity1 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot1')) {
        blehumidityArr.push(_data[0].slot1name + ': ' + _data[0].blehumidity1 + ' %')
      }
      if (_data[0].blehumidity2 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot2')) {
        blehumidityArr.push(_data[0].slot2name + ': ' + _data[0].blehumidity2 + ' %')
      }
      if (_data[0].blehumidity3 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot3')) {
        blehumidityArr.push(_data[0].slot3name + ': ' + _data[0].blehumidity3 + ' %')
      }
      if (_data[0].blehumidity4 != '0' && (_that.alert.info.split('|')[2] == undefined || _that.alert.info.split('|')[2] == 'slot4')) {
        blehumidityArr.push(_data[0].slot4name + ': ' + _data[0].blehumidity4 + ' %')
      }
      _that.blehumidity = blehumidityArr.join(', ');
    })

  }

  openAlertTypeNlb(_ev) {
    if (this.alert.notetype != '' || this.mustnote == false) return false;
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'alerttypenlb', selected: 0, callback: function (_text, _ids) {
        _that.alerttypenlb = _ids
        _that.alerttypenlbtxt = _text
      }
    });
    popover.present({ ev: _ev });
  }

  updateAlert() {
    var _that = this;
    if (this.gn.clientsettings.clienttypeid + '' == '18' && this.alerttypenlb == 'test')
      this.zabeleshka = this.alerttypenlbtxt;

    if (this.zabeleshka != '' && this.zabeleshka != null) {
      this.gn._Post('/api/gn/updatealarm', {
        vid: this.gn.crypt(this.alert.vehicleid),
        dt: this.gn.crypt(this.alert.datatext),
        uid: this.gn.crypt(this.gn.user.UserId),
        note: this.gn.crypt(this.zabeleshka),
        notetype: this.gn.crypt(this.alerttypenlb),
        type: this.gn.crypt(this.alert.name)
      }, function (_data) {
        if (_data.msg == 'OK') {
          _that.gn.getNotifications();
          _that.navCtrl.pop()
        }
      })
    } else {
      const toast = this.toastCtrl.create({ message: this.dic.l["mustnote"], duration: 3000, position: 'top' });
      toast.present();
    }
  }
  showFuelDropDetails() {
    let alertModal = this.modalCtrl.create(FueldropdetailsPage, { pochFuel: this.pochFuel, dtfueldown: this.dtfueldown, fulldt: this.historyObj.fulldt, vehicleid: this.historyObj.vehicleid }, { cssClass: "modal-fullscreen2" });
    alertModal.present();
  }
  getAllDataHistory() {
    var _that = this;
    this.gn._Post('/api/gn/gethistoryofalertpoint', { vid: this.gn.crypt(this.alert.vehicleid), dt: this.gn.crypt(this.alert.datatext) }, function (_data) {
      if (_data[0].getdatafromhlkiki != "") {
        _that.historyObj = _that.vs.parseData(_data[0].getdatafromhlkiki);
        if (_that.historyObj.location == '') { _that.historyObj.location = '/' }
        if (_that.historyObj.zonenames == '') { _that.historyObj.zonenames = '/' }
        _that.historyObj.speed = _that.historyObj.speed.replace('NaN', '0')
        _that.kraenDatumFuel = _that.historyObj.datatext;
      }
      _that.loadMapNotif();
      _that.dataLoaded = true
    })
  }

  loadVehiclesOnMap() {
    if (this.historyObj != undefined) {
      var _that = this;

      var _lon = parseFloat(this.historyObj.lon)
      var _lat = parseFloat(this.historyObj.lat)

      // console.log(_lat,_lon,this.historyObj)
      var el = document.createElement("DIV");
      el.className = "gn-ol-market" + this.gn.user.vehsize + " gn-car-" + this.historyObj.color
      el.innerHTML = '<span style="z-index:1; position: relative">' + this.alert.code + '</span><span class="gn-nouse' + this.gn.user.vehsize + '"></span>'
      el.setAttribute('car-code', this.alert.code)
      el.setAttribute('id', 'gncar-' + this.alert.code)


      var marker = new RichMarker({
        position: new google.maps.LatLng(_lat, _lon),
        map: this.MapNotif,
        content: el.outerHTML,
        anchor: RichMarkerPosition.MIDDLE
      });

      this.MapNotif.setCenter({ lat: _lat, lng: _lon })
    }
  }

  differenceDatesNumber(date1, date2) {
    date1 = moment(date1);
    date2 = moment(date2);
    var duration = moment.duration(date1.diff(date2));
    var secounds = parseInt(duration.asSeconds() + '');
    // console.log('diffference')
    return secounds;
  }

  differenceDatesNumber1(date1, date2) {
    date1 = moment(date1);
    date2 = moment(date2);
    var duration = moment.duration(date1.diff(date2));
    var minutes = parseInt(duration.asMinutes() + '');
    // console.log('diffference')
    return minutes;
  }

  ionViewDidLoad() {
    //////
    var now = new Date();
    var sec = this.differenceDatesNumber(now, this.alert.datatext)
    var min = this.differenceDatesNumber1(now, this.alert.datatext)
    var overmin = 3;
    //console.log('Now sec ' + sec, 'Now minutes ' + overmin * 60, 'Minutes: ' + min)
    if (sec > (overmin * 60 + 10)) {
      this.deblockBtn = true;
    } else {
      var _that = this;
      this.sectodeblock = ((overmin * 60 + 10) - _that.differenceDatesNumber(now, _that.alert.datatext) + 1)
      this.myInterval = setInterval(function () {
        //console.log('AAAAA ' + _that.differenceDatesNumber1(now, _that.alert.datatext), _that.differenceDatesNumber(now, _that.alert.datatext))
        if (_that.deblockBtn == true) {
          clearInterval(_that.myInterval);
          _that.myInterval = null;
        } else {
          now = new Date();
          sec = _that.differenceDatesNumber(now, _that.alert.datatext)
          if (sec > (overmin * 60 + 10)) {
            _that.deblockBtn = true;
          } else {
            _that.sectodeblock = ((overmin * 60 + 10) - _that.differenceDatesNumber(now, _that.alert.datatext) + 1)
          }
        }
      }, 1000)
    }
    //////
    this.getAllDataHistory()
    // console.log('ionViewDidLoad NotificationmodalPage');
  }

  ionViewWillLeave() {
    clearInterval(this.myInterval)
    this.myInterval = null
  }


  loadMapNotif() {
    // console.log("POVIKUVA MAPA")
    this.MapNotif = new google.maps.Map(document.getElementById('mapNotif'), {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 15
    });
    this.MapNotif.setCenter({ lat: 41.998802, lng: 21.427379 })
    this.loadVehiclesOnMap();
  }

  blockunblock(_i) {
    var _command = ''
    var _mess = ''
    if (_i == 0) {
      _command = 'unblock';
      _mess = this.dic.l["succunblock"];
    } else {
      _command = 'block';
      _mess = this.dic.l["succblock"];
    }

    //this.gn.Socket.emit({}, null, 'testnlb')
    var _that = this;
    let alertModal = this.modalCtrl.create(ConfirmreqPage, {
      cb: function () {
        _that.gn.Socket.emit({ vid: _that.alert.vehicleid, gsmnum: _that.gn.Vehicles[_that.gn.VehiclesDic[_that.alert.vehicleid]].gsmnum, type: 'panoramanew_blockunblock', command: _command }, function (_data) {
          //_that.gn.Socket.emit({ vid: 2368, gsmnum: '121212', type: 'panoramanew_blockunblock', command: _command }, function (_data) {
          if (_data.indexOf('vehicleNotConnected') != -1) {
            _mess = _that.dic.l["notsuccblock"];
          } else {
            if (_data.indexOf('CaNotConnected') != -1) {
              _mess = _that.dic.l["canotconnected"]; //Проблем во комуникацијата меѓу сервисите
            } else {
              _that.gn.Vehicles[_that.gn.VehiclesDic[_that.alert.vehicleid + '']].engineblock = _i;
            }
          }
          const toast = _that.toastCtrl.create({ message: _mess, duration: 3000, position: 'top' });
          toast.present();
        }, 'sendcommnlb')
      }
    }, { cssClass: "modal-fullscreen4" });
    alertModal.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/notificationmodal/notificationmodal.ts